import { render } from "./Project.vue?vue&type=template&id=1670b770&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=1670b770&lang=scss"
import "./Project.vue?vue&type=style&index=1&id=1670b770&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1670b770"

export default script